import { createSelector } from "reselect";
const selectColorChartsState = createSelector((state) => state.colorCharts, state => state);
const selectColorCharts = createSelector(selectColorChartsState, state => state.infos);
export { selectColorCharts };
